import { positionToStyle } from './positionToStyle';

/**
 * 构造absolute定位对象，positionToStyle别名方法
 * @param {*} position
 * @returns
 */
export function positionToStyleForAbsolute(position) {
    return positionToStyle(position);
}
